export default "__VITE_ASSET__5WqhdQ4u__"